import React, { useState, useEffect, useCallback } from "react";
import { Form } from "react-bootstrap";
import Multiselect from "multiselect-react-dropdown";
import { beApiUrl } from "../api/be_config";

export default function EntitySearchInput({ 
  value, 
  onChange, 
  placeholder = "Search entity names...",
  label,
  disabled = false 
}) {
  const [nameOptions, setNameOptions] = useState([]);

  // 防抖函数
  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(null, args), delay);
    };
  };

  // Entity Name 前缀搜索函数
  const searchEntityNames = async (prefix) => {
    if (!prefix || prefix.trim() === '') {
      return;
    }
    
    try {
      const response = await fetch(beApiUrl + "kgpage/entity_name_search/v1/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ 
          prefix: prefix.trim(),
          limit: 10 
        }),
      });
      
      if (!response.ok) {
        throw new Error("Failed to search entity names.");
      }
      
      const data = await response.json();
      // 将字符串数组转换为对象数组，以匹配现有的数据结构
      const formattedData = data.data.map(name => ({ name: name }));
      setNameOptions(formattedData);
    } catch (error) {
      console.log(error);
    }
  };

  // 创建防抖版本的搜索函数
  const debouncedSearchEntityNames = useCallback(debounce(searchEntityNames, 300), []);

  // 初始化数据
  useEffect(() => {
    fetch(beApiUrl + "kgpage/entity_name/v1/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ size_limit: 10 }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to get the entity names.");
        }
        return response.json();
      })
      .then((data) => {
        setNameOptions(data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <Form.Group className="mb-3">
      {label && <Form.Label>{label}</Form.Label>}
      <Multiselect
        options={nameOptions}
        displayValue="name"
        onRemove={(selectedList) => onChange(selectedList)}
        onSelect={(selectedList) => onChange(selectedList)}
        onSearch={(value) => debouncedSearchEntityNames(value)}
        placeholder={placeholder}
        disable={disabled}
        selectedValues={value}
        selectionLimit={1}
      />
    </Form.Group>
  );
} 